<template>
  <div class='footer'>
    <div class='links'>
      <a class='link-item' href='https://github.com/butterprim' target='_blank'>Github</a> /
      <a class='link-item' href='https://codepen.io/butterprim' target='_blank'>Codepen</a> /
      <a class='link-item' href='https://instagram.com/butterprim' target='_blank'>Comics</a>
    </div>
    <div class='copyright'><span class="icon">copyright</span> Lizette Daluz 2020</div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
.footer {
  box-sizing: border-box;
  padding: 1rem;
  background: #2D2D2D;
  color: #fff;
  font-size: 0.85rem;
}

.link-item {
  display: inline-block;
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}

.links, .copyright {
  margin: 0.5rem 0;
}

.copyright {
  display: flex;
  margin-top: 1rem;
}

.copyright .icon {
  align-self: center;
  margin-right: 5px;
}

@media screen and (min-width: 480px) {
  .footer {
    padding: 1rem 5%;
    font-size: 1rem;
    display: flex;
    flex-direction: row;
  }

  .links {
    flex: 1;
  }

  .copyright {
    margin: 0.5rem 0;
  }
}

@media screen and (min-width: 1024px) {
  .footer {
    padding: 1rem 10%;
  }
}
</style>

